import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useCountriesOptions } from '@/api/countries';
import { FieldInput } from '@/components/form/field-input';
import { FieldSelect } from '@/components/form/field-select';

import type { EstateValidationSchemaType } from '../../schemas/estate-validation';

export const LocationForm = () => {
  const { t } = useTranslation();

  const { data: countries } = useCountriesOptions();

  const methods = useFormContext<EstateValidationSchemaType>();

  return (
    <div className="space-y-2">
      <h4 className="text-md font-bold">{t('location')}</h4>
      <FieldInput methods={methods} name="address.address" label={t('address')} />
      <FieldInput methods={methods} name="address.street" label={t('street')} />
      <FieldInput methods={methods} name="address.houseNumber" label={t('houseNumber')} />
      <FieldInput methods={methods} name="address.city" label={t('city')} />
      <FieldInput methods={methods} name="address.postalCode" label={t('postalCode')} />
      <FieldSelect
        methods={methods}
        name="address.countryId"
        label={t('country')}
        options={countries}
      />
    </div>
  );
};
